import React from 'react';
import { FaPaperPlane } from 'react-icons/fa';
import { useModal } from "src/hooks/Modal";
import { useToast } from "src/hooks/Toast";
import FormComponent from 'src/pages/DashboardPages/core/components/FormComponent';
import api from "src/services/api";

export default function useUploadAvaliators({projectHash}){


const {addModal, removeModal} = useModal();
const {addToast} = useToast();


const confirmate = async (data) => {


let x = 0;
while( x < data?.length){

const i = data[x];
   if(i?.id){

            
            await api.put(`/students/${i?.id}/project_id`,{ project_id : projectHash});
            await api.put(`/students/${i?.id}/type`,{ type : i?.CATEGORIA});
            await api.put(`/students/${i?.id}/category_id`,{ category_id : i?.AREA});
            await api.put(`/students/${i?.id}/subarea`,{ subarea : i?.SUBAREA});
            await api.put(`/students/${i?.id}/profile`,{ profile : 12});
            sendPassword({project_id : projectHash, _id: i?.id, name: i?.NOME})

        }
        else{


            await api.post(`/students`,{
                project_id: projectHash,
                name: i?.NOME,
                email: i?.EMAIL,
                profile: 12,
                type: i?.CATEGORIA || '',
                category_id: i?.AREA || '',
                subarea: i?.SUBAREA || ''



            })


        }

    x += 1;

}
    data?.map(async ( i) => {


     
        
        addToast({title:`${i?.NOME} - ${i?.EMAIL}`})



    })



}


  const setCallback = async (
    data: Record<string, any>,
 
  ): Promise<void> => {
    try {
      const formData = new FormData();
      formData.append('file', data.image)

    const students = await api.get('/students', { params: { limitItems: 100000}})

      const response = await api.post(`/xlsx-to-json`, formData);

      if (response.status !== 200) {
        return addToast({ type: 'error', title: 'Erro ao salvar' });
      }


const dataList : Record<string,any>[] = [];


response?.data?.map( i => {

    i.EMAIL = i?.EMAIL?.trim()?.toLowerCase();
    i.CATEGORIA = i?.CATEGORIA?.trim();
       i.AREA = i?.AREA?.trim();
        i.SUBAREA = i?.SUBAREA?.trim();

    const student = students?.data?.rows?.find( a => a?.email?.trim()?.toLowerCase() === i?.EMAIL?.trim()?.toLowerCase());

    const indexData = dataList?.findIndex( a => a?.EMAIL === i?.EMAIL);

    if(student && indexData >= 0){

        if(i?.CATEGORIA){
dataList[indexData].CATEGORIA =  dataList[indexData].CATEGORIA ? `${dataList[indexData].CATEGORIA} | ${i?.CATEGORIA}` : i?.CATEGORIA
        }

                if(i?.AREA ){
dataList[indexData].AREA = dataList[indexData].AREA ? `${dataList[indexData].AREA} | ${i?.AREA}` : i?.AREA
        }

                if(i?.SUBAREA){
dataList[indexData].SUBAREA = dataList[indexData].SUBAREA ? `${dataList[indexData].SUBAREA} | ${i?.SUBAREA}` : i?.SUBAREA
        }


    }
    else if(student){

      
if(student?.project_id !== projectHash){
        dataList.push({...i, EXISTE: 'Sim', id: student?._id?.toString()})
}



    }
    else if(indexData >= 0){

        if(i?.CATEGORIA){
dataList[indexData].CATEGORIA =  dataList[indexData].CATEGORIA ? `${dataList[indexData].CATEGORIA} | ${i?.CATEGORIA}` : i?.CATEGORIA
        }

                if(i?.AREA){
dataList[indexData].AREA = dataList[indexData].AREA ? `${dataList[indexData].AREA} | ${i?.AREA}` : i?.AREA
        }

                if(i?.SUBAREA){
dataList[indexData].SUBAREA = dataList[indexData].SUBAREA ? `${dataList[indexData].SUBAREA} | ${i?.SUBAREA}` : i?.SUBAREA
        }

    }
    else{


        dataList.push({...i, EXISTE: 'Não'})



    }



})


      removeModal('modal');

      const content = <>
        <table className='tableRef'>
          <tbody>
            <tr><td>Existe</td><td>Nome</td><td>E-mail</td><td>Categoria</td><td>Área</td><td>Subárea</td></tr>
            {dataList?.map(item => {
          
              return <tr   ><td>{item?.EXISTE}</td><td>{item?.NOME}</td><td>{item?.EMAIL}</td><td>{item?.CATEGORIA}</td><td>{item?.AREA}</td><td>{item?.SUBAREA}</td></tr>
            })}
          </tbody>
        </table>
        <button onClick={() => { confirmate(dataList) }} className='defaultButtonReverse'>Confirmar</button>
      </>

      if (content) {
        const keyModal = addModal({ title: 'Adicionar Áreas', content, key: 'confirmaArea', theme: "whiteModal" });
      }



    } catch (err) {
      if (err ) {
         
        return;
      }

      return addToast({ type: 'error', title: err?.response?.data?.error || err?.response?.data?.message });
    }
  };

  const createUpload = (): void => {
    const content = (
      <FormComponent schema={{
        image: {
          model: 'uploadImage',
          type: 'upload',
          name: 'image',
          label: 'Imagem',
        }
      }} setCallback={setCallback} />
    );
    if (content) {
      const keyModal = addModal({ title: 'Upload de Áreas', content, key: 'modal', theme: "whiteModal" });
    }
  };


    const sendPassword = async (lineData) => {
      try {
        await api.post(`/send-password-residencia/${lineData?.project_id}/${lineData?._id?.toString()}`);
        removeModal('sendPassword');
        addToast({ title: `${lineData?.name} - Enviado com sucesso`, type: 'success' });
      }
      catch (err) {
        addToast({ title: 'Erro ao enviar', type: 'error' });
      }
  
    }

    const sendToList = (data) => {

data?.map( async (item) => {


  await  sendPassword(item)


})



    }


  const listAvaliators = async (
  
 
  ): Promise<void> => {
    try {
   
    const students = await api.get('/students', { params: { limitItems: 100000, where: { project_id : projectHash, profile: 12}}})

 
 

      const content = <>
     <button onClick={() => { sendToList(students?.data?.rows) }} className='defaultButtonReverse'>Confirmar</button>
   

        <table className='tableRef'>
          <tbody>
            <tr><td></td><td>Nome</td><td>E-mail</td><td>Categoria</td><td>Área</td><td>Subárea</td></tr>
            {students?.data?.rows?.map(item => {
          
              return <tr   ><td><FaPaperPlane onClick={() => { sendPassword(item) }} size={30}/></td><td>{item?.name}</td><td>{item?.email}</td><td>{item?.type}</td><td>{item?.category_id}</td><td>{item?.subarea}</td></tr>
            })}
          </tbody>
        </table>
      </>

      if (content) {
        const keyModal = addModal({ title: 'Avaliadores', content, key: 'confirmaArea', theme: "whiteModal" });
      }



    } catch (err) {
      if (err ) {
         
        return;
      }

      return addToast({ type: 'error', title: err?.response?.data?.error || err?.response?.data?.message });
    }
  };


    return {createUpload, listAvaliators}

}